import React from 'react';

const PencilFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7 4.8L3.6 16 8 20.4 19.2 9.3l-4.5-4.5zM17.5 2l-2.1 2.1 4.5 4.5L22 6.5zM2 22l5.1-1.1-4-4z"
        />
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M12 21h2v1h-2zM16 21h2v1h-2zM20 21h2v1h-2z" />
        </g>
    </svg>
);

PencilFillSvg.displayName = 'PencilFillSvg';
export default PencilFillSvg;
